import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function BlockIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M18.6667 5H5.33334C4.97972 5 4.64057 5.14048 4.39053 5.39052C4.14048 5.64056 4 5.97972 4 6.33333V9.66667C4 10.0203 4.14048 10.3594 4.39053 10.6095C4.64057 10.8595 4.97972 11 5.33334 11H18.6667C19.0203 11 19.3594 10.8595 19.6095 10.6095C19.8595 10.3594 20 10.0203 20 9.66667V6.33333C20 5.97972 19.8595 5.64056 19.6095 5.39052C19.3594 5.14048 19.0203 5 18.6667 5Z"
        fill="currentColor"
      />
      <path
        d="M18.6667 13H5.33334C4.97972 13 4.64057 13.1405 4.39053 13.3905C4.14048 13.6406 4 13.9798 4 14.3334V17.6668C4 18.0203 4.14048 18.3594 4.39053 18.6095C4.64057 18.8596 4.97972 19 5.33334 19H18.6667C19.0203 19 19.3594 18.8596 19.6095 18.6095C19.8595 18.3594 20 18.0203 20 17.6668V14.3334C20 13.9798 19.8595 13.6406 19.6095 13.3905C19.3594 13.1405 19.0203 13 18.6667 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
